export class Commons {

  /** 確認ボタンイベント初期化済みフラグ */
  static _confirmBtnInitialized: boolean = false;

  // URL Clientディレクトリ取得
  static getClientDir = (): string => {
    const currentPath = location.pathname;
    return currentPath.split("/")[1];
  };
  /**
   * URLからメソッド名を作る num 何番目からパスを作る（配列番号）
   */
  static createMethod = (num: number = 1): string[] => {
    let result: string[] = [];
    let path = location.pathname.replace(/\.(html|php)$/, "");
    path = path.replace(/^\//, "");
    result = path.split("/");
    if (num > 0) {
      for (let i = 0; i < num; i++) {
        result.shift();
      }
    }
    return result;
  };
  /**
   * 配列要素を連結させて、連結スタイルをキャメルケースにする
   */
  static arrayToCamelCase = (arr: string[]): string => {
    // map()を使って各要素を変換
    const camelizedArray = arr.map((word, index) => {
      // 最初の単語はそのまま小文字にする
      if (index === 0) {
        return word.toLowerCase();
      }
      // 2番目以降の単語は、最初の文字を大文字、それ以降を小文字にする
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });

    // join()を使って区切り文字なしで連結
    return camelizedArray.join("");
  };
  /**
   * フッター位置を調整する
   */
  static fixedFooter = (): void => {
    const container = document.querySelector<HTMLElement>("#main");
    const footer = document.querySelector<HTMLElement>("#footer");
    if (!container || !footer) return;
    if (
      window.innerHeight >
      container.clientHeight + 40 + footer.clientHeight
    ) {
      container.style.height = `${window.innerHeight}px`;
    }
    footer.style.opacity = "1";
  };

  /**
   * 表示日情報を返却する
   */
  static getSelectDate = async (): Promise<string> => {
    const cd = document.querySelector<HTMLInputElement>('[name="d"]');
    const today = new Date();
    const LDM = new Date(today.getFullYear(), today.getMonth(), 0);
    if (!cd) {
      return `${LDM.getFullYear()}-${String(LDM.getMonth() + 1).padStart(2, "0")}-${String(LDM.getDate()).padStart(2, "0")}`;
    }
    return cd.value;
  };
  /**
 * セレクト表示情報を返却する
 */
  static getSelectOption = async (name: string): Promise<{ text: string; value: number }> => {
    const sel = document.querySelector<HTMLSelectElement>(`select[name="${name}"]`);
    const result = { text: "", value: 0 };
    if (!sel || sel.selectedIndex < 0) {
      return result;
    }
    const op = sel.options[sel.selectedIndex];
    result.value = Number(op.value);
    result.text = op.text;
    return result;
  };

  /**
   * セレクトを変更したときのイベント
   */
  static changeSelectEvent = () => {
    const cls = document.getElementsByClassName("selectEvent");
    if (cls.length === 0) {
      return;
    }
    Array.from(cls).forEach((elm) => {
      if (!(elm instanceof HTMLSelectElement)) return;
      elm.addEventListener("change", () => {
        let currentUrl = window.location.href;
        let urlObj = new URL(currentUrl);
        urlObj.searchParams.set(elm.name, elm.value);
        window.location.href = urlObj.toString();
      });
    });
  };

  /**
   * フィルター検索Event
   */
  static changeFilterEvent = (btnId: string): void => {
    const filterSubmit = document.getElementById(btnId);
    if (!filterSubmit) {
      return;
    }
    filterSubmit.addEventListener("click", e => {
      e.preventDefault(); // ★必須
      const cls = document.getElementsByClassName("searchElm");
      if (cls.length > 0) {
        let currentUrl = window.location.href;
        let urlObj = new URL(currentUrl);
        Array.from(cls).forEach((elm) => {
          if (!(elm instanceof HTMLSelectElement)) return;
          urlObj.searchParams.delete(elm.name);
          if (elm.value.length > 1 || Number(elm.value) > 0) {
            urlObj.searchParams.set(elm.name, elm.value);
          }
        });
        window.location.href = urlObj.toString();
      }
    });
  };
  /**
   * 検索結果をタグとして表示する
   */
  static searchResults = (): void => {
    const tagArea = document.getElementById("searchResult");
    if (tagArea) {
      tagArea.innerHTML = '<small class="me-1 fw-bold">表示データ:</small>';
      const tag = document.createElement("span");
      tag.className = "badge text-bg-secondary me-1";
      tag.id = "searchAll";
      tag.textContent = "すべて";
      tagArea.appendChild(tag);
      const params = new URLSearchParams(window.location.search);
      if (params.size > 0) {
        params.forEach((value, key) => {
          const select = document.querySelector(`select[name="${key}"]`);
          if (!select) return;

          const option = select.querySelector(`option[value="${value}"]`);
          if (!option) return;
          const searchAll = document.getElementById("searchAll");
          if (searchAll) {
            searchAll.remove();
          }
          // タグ表示例
          const tag = document.createElement("span");
          tag.className = "badge text-bg-secondary me-1";
          tag.style.cursor = "pointer";
          tag.innerHTML = `${option.textContent} <span aria-hidden="true">&times;</span>`;
          tagArea.appendChild(tag);

          // ×を押したときの処理
          tag.addEventListener("click", () => {
            // URL パラメータから対象キーを削除
            params.delete(key);
            // パラメータ無しなら '?' を消す
            const newQuery = params.toString();
            const newUrl = newQuery ? `?${newQuery}` : window.location.pathname;
            // URL を書き換えて再読み込み
            window.location.href = newUrl;
          });
        });
      }
    }
  };

  /**
   * スコアから指定形式に返却する
  */
  static riskElm = (
    volume: number = 0,
    riskObj: {
      score: number;
      class: string;
      text: string;
      htmlRound: string;
      html: string;
      htmlRem: string;
      rgba: string;
    }[] = [],
    type: string = '',
    disp: boolean = false
  ): {text: string, rgba: string} | '' => {
    let result: {text: string, rgba: string} | '' = '';
    if (disp && riskObj && riskObj.length > 0) {
      result = type
        ? riskObj[riskObj.length - 1][type]
        : riskObj[riskObj.length - 1];
      for (let i = 0; i < riskObj.length; i++) {
        if (volume > riskObj[i].score) {
          result = type ? riskObj[i - 1][type] : riskObj[i - 1];
          break;
        }
      }
    }
    return result;
  };
  /**
   * bootstrapのtooltipイベント
   */
  static tooltip = () => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    if (tooltipTriggerList.length === 0) {
      return;
    }
    [...tooltipTriggerList].map(
      (tooltipTriggerEl) =>
        new bootstrap.Tooltip(tooltipTriggerEl, {
          sanitize: false,
          customClass: "tooltip-multiline",
          template:
            '<div class="tooltip tooltip-multiline" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        })
    );
  };

  /**
   * 数字が０以上ならば＋をつけて返却
   */
  static numberPlusFormat = (num: number, arrow: UpDownArrow): string => {
    let result = `${num}${arrow.even}`;
    if (num > 0) {
      result = `+${num}${arrow.up}`;
    } else if (num < 0) {
      result = `${num}${arrow.down}`;
    }
    return result;
  };
  /**
   * 管理者チェック
   */
  static isAdmin = (
    userAuthData: {
      authority: number
    }): boolean => {
    return userAuthData.authority > 6 ? true : false;
  };
  /**
   * ページ上部へ移動
   */
  static scrollToTop = (): void => {
    const backToTop = document.getElementById("backToTop");
    if (!backToTop) return;
    // スクロールしたらボタン表示
    window.addEventListener("scroll", () => {
      if (window.scrollY > 300) {
        backToTop.classList.add("show");
      } else {
        backToTop.classList.remove("show");
      }
    });
    // スムーズスクロールでトップへ（URLは変化しない）
    backToTop.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  };
  /**
   * ページ内リンク
   */
  static scrollToName = (): void => {
    const pLink = document.querySelectorAll<HTMLElement>(".pLink");
    if (pLink.length === 0) return;
    pLink.forEach(link => {
      const targetId = link.dataset.name ?? '';
      if (!targetId) return; // 要素が見つからないなら終了
      const elm = document.getElementById(targetId);
      if (!elm) return; // 要素が見つからないなら終了
      link.addEventListener("click", (e) => {
        e.preventDefault(); // リロード防止
        elm.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      });
    });
  };
  /**
   * input valueをリセットする
   */
  static valueReset = (): void => {
    document.querySelectorAll(".valueReset").forEach((btn) => {
      btn.addEventListener("click", e => {
        const target = e.target as HTMLElement | null;
        if (!target) return;
        const targetName = target.getAttribute("data-name");
        if (!targetName) return;
        const elm = document.querySelector<HTMLInputElement>(`[name=${targetName}]`);
        if (elm) {
          elm.value = "";
        }
      });
    });
  };

  /**
  * チェックされたフィルタ条件を取得
  */
  static collectFilters = (filterCol: string[], formSelector: string = '#filterForm'): Record<string, string[]> => {
    const filters: Record<string, string[]> = {};
    filterCol.forEach(field => {
      const checked = document.querySelectorAll<HTMLInputElement>(
        `${formSelector} input[name="${field}"]:checked`
      );
      filters[field] = Array.from(checked).map(cb => cb.value);
    });
    return filters;
  }

  /**
   * List.js にフィルタを適用
   */
  static applyListFilter = (
    listObj: ListLike,
    filters: Record<string, string[]>
  ): void => {
    listObj.filter((item) => {
      const values = item.values();
      for (const field in filters) {
        if (
          filters[field].length > 0 &&
          !filters[field].includes(values[field])
        ) {
          return false;
        }
      }
      return true;
    });
  };

  /**
   * フィルタフォームのチェックボックスを解除
   */
  static resetFilterCheckbox = (formSelector: string = '#filterForm') => {
    const checkboxes = document.querySelectorAll<HTMLInputElement>(
      `${formSelector} input[type="checkbox"]`
    );
    checkboxes.forEach(cb => cb.checked = false);
  }
  /**
   * 確認済状態のUIに変更する
   */
  static markConfirmed = (btn: HTMLButtonElement): void => {
    btn.classList.remove('btn-outline-secondary');
    btn.classList.add('btn-success');
    btn.innerHTML = '<i class="bi bi-check-lg"></i> 確認済';
    btn.disabled = true;
  }
  /**
   * 指定した名前の Cookie を取得する Cookieの値（存在しない場合は null）
   */
  static getCookie = (name: string): string | null => {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name) {
        return decodeURIComponent(value);
      }
    }
    return null;
  }
  /**
   * Cookieを設定する
   * name Cookie名
   * value Cookieの値
   * [days=365] 有効期限（日数）
   */
  static setCookie = (name: string, value: string, days: number = 365): void => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
  }
  /**
  * 確認状態イベント初期化
  */
  static confirmBtn = (): void => {
    // 既読反映（初期表示）
    const confirmed = this.getCookie('confirmed_notice_ids');
    const confirmedIds = confirmed ? confirmed.split(',') : [];
    const buttons = document.querySelectorAll<HTMLButtonElement>('.confirm-btn');
    if (buttons.length === 0) return;
    buttons.forEach(btn => {
      const id = btn.dataset.noticeId;
      if (id && confirmedIds.includes(id)) {
        this.markConfirmed(btn);
      }
    });

    // イベント多重登録防止
    if (this._confirmBtnInitialized) return;
    this._confirmBtnInitialized = true;

    document.addEventListener('click', e => {
      const target = e.target as HTMLElement | null;
      if (!target) return;
      const btn: HTMLButtonElement | null = target.closest('.confirm-btn');
      if (!btn) return;
      const id = btn.dataset.noticeId;
      if (!id) return;
      let confirmed = this.getCookie('confirmed_notice_ids');
      let confirmedIds = confirmed ? confirmed.split(',') : [];
      if (!confirmedIds.includes(id)) {
        confirmedIds.push(id);
        this.setCookie('confirmed_notice_ids', confirmedIds.join(','));
        //count_badge
        this.countBadge(1);
      }
      this.markConfirmed(btn);
    });
  }
  /**
   * カウンターバッジの数字を更新する
   * num 表示から引く数字
   */
  static countBadge = (num: number = 0): void => {
    const countBadge = document.querySelector('#countBadge');
    if (countBadge) {
      const current = parseInt(countBadge.textContent, 10) || 0;
      countBadge.textContent = String(Math.max(current - num, 0));
    }
  }
  /**
   * カウンターバッジの更新を行う
   */
  static updateBadgeByCookie = (): void => {
    const badge = document.getElementById('countBadge');
    if (!badge) return;

    const total = parseInt(badge.textContent, 10) || 0;

    const confirmed = Commons.getCookie('confirmed_notice_ids');
    const confirmedCount = confirmed ? confirmed.split(',').length : 0;

    const remain = Math.max(total - confirmedCount, 0);
    badge.textContent = String(remain);
  }
  /**
   * formタグのvalueに値セットする
   */
  static setValue = (selector: string, value: string | null): void => {
    if (!value) return;
    const el = document.querySelector<HTMLInputElement>(selector);
    if (el) el.value = value;
  };
  /**
   * Bootstrap の show.bs.modal 用：Event から relatedTarget を安全に取り出す
   */
  static getRelatedTarget = (e: Event): HTMLElement | null => {
    return (e as ModalEvent).relatedTarget;
  }
  /**
  * data-* 属性を取得するユーティリティ
  */
  static getData = <T extends string>(el: HTMLElement, key: T): string | null => {
    return el.getAttribute(`data-${key}`);
  }

}
